import { apicall } from "../../../services/api";
import {  ALL_EMPLOYEES, CREATE_EMPLOYEE, EMPLOYEE, ERR_EMPLOYEES, REMOVE_EMPLOYEE, REMOVE_USER, UPDATE_EMPLOYEE } from "../actionTypes";
import { getAllUsers } from "../user.actions";

import { setAlert } from "../alert.actions";
import { toast } from "react-toastify";


export const getAllEmployee = () => async (dispatch) => {
    try {
        const res = await apicall(`teams/`, "get");
  
        dispatch({
            type: ALL_EMPLOYEES,
            payload: res.data.data,
        });
    } catch (err) {
        console.log(err);
        dispatch(setAlert(err.response.data.msg, "error"));
    }
};

export const getEmployee = (userId) => async (dispatch) => {
    try {
        const res = await apicall(`teams/${userId}`, "get");
        dispatch({
            type: EMPLOYEE,
            payload: res.data,
        });
        toast.success(res.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
        return res.data.data
    } catch (err) {
        dispatch({
            type: ERR_EMPLOYEES,
            payload: { msg: err.response.statusText, status: err.response.status },
        });
        toast.error(err.response.data.msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
};

export const createEmployee = (data) => async (dispatch) => {
    try {
        const res = await apicall("/teams/", "post", data);
        dispatch({
            type: CREATE_EMPLOYEE,
            payload: res.data,
        });

        dispatch(getAllEmployee());
        toast.success(res.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    } catch (err) {
        dispatch({
            type: ERR_EMPLOYEES,
            payload: { msg: err.response.statusText, status: err.response.status },
        });
        toast.error(err.response.data.msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
};

export const updateEmployee = (userId, data) => async (dispatch) => {
    try {
        const res = await apicall(`/teams/${userId}`, "patch", data);
        dispatch({
            type: UPDATE_EMPLOYEE,
            payload: res.data,
        });
        dispatch(getAllUsers());
        // dispatch(setAlert(res.data.message, "success"));
        toast.success(res.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    } catch (err) {
        dispatch({
            type: REMOVE_EMPLOYEE,
            payload: { msg: err.response.statusText, status: err.response.status },
        });
        toast.error(err.response.data.msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
};

export const deleteEmployee = (userId) => async (dispatch) => {
    if (window.confirm("Are you sure? This can NOT be undone!")) {
        try {
            const res = await apicall(`/teams/${userId}`, "delete");
            dispatch({ type: REMOVE_USER, payload: userId });
            dispatch(getAllEmployee())
            // dispatch(setAlert(res.data.message, "success"));
            toast.success(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (err) {
            console.log("err", err);
            dispatch({
                type: ERR_EMPLOYEES,
                payload: { msg: err.response.msg, status: err.response.status },
            });
            toast.error(err.response.data.msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
};
